/**
 * Helpers for a push tap that arrives as a NAVIGATE message from the service worker (FLIP-475).
 * The URL is a path + query inside this app, e.g. "/score" or "/community?post=%2Ftopic%2F37".
 */

/**
 * True for a path inside this app. The service worker only sends such a path, but the message listener is
 * the other half of that trust boundary, so it checks again rather than hand any string to the router:
 * a single leading "/", no "//" (protocol-relative), no backslash, no scheme.
 */
export function isAppPath(url: unknown): url is string {
  return (
    typeof url === "string" &&
    url.startsWith("/") &&
    !url.startsWith("//") &&
    !url.includes("\\") &&
    !url.includes("://")
  );
}

/** The path part of an app URL, without its query or fragment: "/community?post=x" -> "/community". */
export function pathOf(url: string): string {
  return url.split(/[?#]/)[0];
}

/**
 * Which kind of notification a tapped URL belongs to. Looks at the path only, so "/score?x=1" is still a Score
 * reminder; "unknown" for everything else (including Community, which has no bell entry to mark seen).
 */
export function notificationTypeFromUrl(url: string): string {
  const path = pathOf(url);
  if (path === "/score" || path.startsWith("/score/")) {
    return "scoreReminder";
  }
  if (path === "/plan" || path.startsWith("/plan/")) {
    return "planReminder";
  }
  if (path === "/brainbites" || path.startsWith("/brainbites/")) {
    return "brainScienceBite";
  }
  return "unknown";
}
